import styled from '@emotion/styled';
import { Field, tokens } from '@hotjar/hotsauce';

export const Page = styled.article`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x4};
`;

export const Wrapper = styled.div`
  width: 600px;
`;

export const StyledField = styled(Field)`
  margin-bottom: ${tokens.spacer.x4};
`;
